<template>
  <div class="box">
    <div class="box__header">
      {{ $t('manage') }}
    </div>
    <el-form-item class="form__buttons" label-width="0">
      <div>
        <component-compiler
          v-for="(component, i) in additionalFields"
          :content="component"
          :key="`form-${i}`"
        />
        <router-link
          :to="{ ...redirectRoute, query: this.$route.query }"
          v-if="!inModal && redirectRoute"
        >
          <el-button class="fluid form__button">{{ $t('cancel') }}</el-button>
        </router-link>
        <el-button
          @click="$emit('submit')"
          type="primary"
          :disabled="submitDisabled"
          class="fluid form__button"
          :loading="loading"
        >
          {{ submitButtonLabel }}
        </el-button>
        <el-alert
          v-if="inModal"
          title="UWAGA"
          show-icon
          :closable="false"
          description="Po zatwierdzeniu zmiany zostaną zapisane niezależnie od formularza, z którego otwarto modal."
          type="warning"
        >
        </el-alert>
      </div>
      <slot></slot>
    </el-form-item>
  </div>
</template>

<script>
import ComponentCompiler from '@/components/ComponentCompiler'

export default {
  props: [
    'redirectRoute',
    'loading',
    'inModal',
    'submitLabel',
    'submitDisabled',
    'additionalFields'
  ],
  components: {
    ComponentCompiler
  },
  computed: {
    submitButtonLabel() {
      return this.submitLabel || this.$t('submit')
    }
  }
}
</script>

<style lang="scss" scoped>
.form__button {
  margin: 0 0 15px !important;
}
</style>
